import { takeEvery, put, select, fork, call } from 'redux-saga/effects';
import moment from 'moment';
// We can't use delay for some reason as it makes PhantomJS choke
// It's probably a bug in PhantomJS but I don't want to investigate that.
// import { delay } from 'redux-saga';
import { asyncSleep } from 'phoenix2/utils';

import {
    STOP_EXPLICIT_WAITING_WITH_DELAY,
    START_EXPLICIT_WAITING,
    SHOW_IMPLICIT_WAITING,
    STOP_EXPLICIT_WAITING,
    STOP_IMPLICIT_WAITING,
    startImplicitWaiting,
    stopImplicitWaiting,
    showImplicitWaiting,
    stopExplicitWaiting,
} from './actions';
import {
    resumeContinuousKpi,
    pauseContinuousKpi,
    kpiNames,
} from 'phoenix2/state/analytics/actions';
import { getExplicitWaitStartTime } from './selectors';

// We need to control the spinning wheel KPI with the implicit and explit wait
// actions. For implicit waits, the spinner does not show until SHOW_ is fired.
// For explicit waits, it shows as soon as START_ is fired and there is no such
// action as SHOW_EXPLICIT_WAIT.
export function* watchStartWaiting() {
    yield takeEvery([START_EXPLICIT_WAITING, SHOW_IMPLICIT_WAITING], function*() {
        yield put(resumeContinuousKpi(kpiNames.SPINNING_WHEEL));
    });
}

export function* watchStopWaiting() {
    yield takeEvery([STOP_EXPLICIT_WAITING, STOP_IMPLICIT_WAITING], function*() {
        yield put(pauseContinuousKpi(kpiNames.SPINNING_WHEEL));
    });
}

export function* wait(effect) {
    yield put(startImplicitWaiting());
    const visibleTask = yield fork(scheduleVisibleWait);
    try {
        return yield effect;
    } finally {
        visibleTask.cancel();
        yield put(stopImplicitWaiting());
    }
}

export function wCall(...args) {
    return wait(call(...args));
}

function* scheduleVisibleWait() {
    // We'd like to do that but PhantomJS doesn't
    // yield call(delay, 500);
    yield call(asyncSleep, 0.5);
    yield put(showImplicitWaiting());
}

export function* watchStopExplicitWaitingWithDelay() {
    yield takeEvery(STOP_EXPLICIT_WAITING_WITH_DELAY, function*({ delay }) {
        const currentMoment = moment();
        const startMoment = yield select(getExplicitWaitStartTime);
        if (startMoment) {
            const cutoff = startMoment.add(delay, 'seconds');
            if (currentMoment.isBefore(cutoff)) {
                const sleepTime = moment.duration(cutoff.diff(currentMoment));
                const seconds = sleepTime.asSeconds();
                yield call(asyncSleep, seconds);
            }
        }
        yield put(stopExplicitWaiting());
    });
}
